var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertMonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32495 38.4022C8.32497 37.1958 8.32497 21.2991 8.32497 21.1614C8.32512 21.1579 8.32491 21.163 8.32506 21.1594C8.33397 21.0457 9.06474 12.0404 17.2356 7.93974C19.4261 6.86091 21.8276 6.27871 24.2689 6.23464C26.7102 6.19057 29.1312 6.68573 31.3592 7.6848C34.7863 9.13965 37.6284 11.6988 39.4334 14.9552C40.6799 17.3222 41.315 19.9632 41.2813 22.6381C41.2813 27.3566 41.2813 37.3716 41.2813 38.2877C41.2807 38.3083 41.2858 38.3286 41.296 38.3465C41.3063 38.3644 41.3213 38.3791 41.3393 38.389C41.82 38.6756 45.1205 40.7614 45.0473 43.9584C45.046 43.9925 45.0316 44.0248 45.0073 44.0486C44.9829 44.0725 44.9503 44.0861 44.9162 44.0866H5.20983C5.17953 44.087 5.15015 44.0762 5.12722 44.0564C5.1043 44.0366 5.08943 44.0091 5.08541 43.979C4.93436 42.8455 5.16288 41.6939 5.73531 40.704C6.30774 39.7141 7.19184 38.9415 8.2496 38.507C8.27126 38.4992 8.29004 38.485 8.30349 38.4663C8.31693 38.4476 8.32442 38.4252 8.32495 38.4022Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5487 38.4746H8.32422",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6368 38.9522C30.928 38.9522 31.1641 38.7161 31.1641 38.4248C31.1641 38.1336 30.928 37.8975 30.6368 37.8975C30.3455 37.8975 30.1094 38.1336 30.1094 38.4248C30.1094 38.7161 30.3455 38.9522 30.6368 38.9522Z",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9967 44.0469C29.9668 48.4749 27.6979 50.4152 24.8622 50.4152C22.0265 50.4152 19.668 48.2957 19.7277 44.0469",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7346 6.42858C21.3963 6.09261 21.1865 5.64873 21.1415 5.17408C20.9962 4.30485 21.1925 3.4131 21.6895 2.68529C22.1864 1.95748 22.9455 1.44996 23.808 1.26886C24.2807 1.18494 24.766 1.2056 25.2299 1.32941C25.6937 1.45322 26.1248 1.67717 26.4928 1.98549C26.8609 2.29381 27.1568 2.67903 27.36 3.11403C27.5631 3.54904 27.6684 4.02327 27.6686 4.50336C27.6686 5.34371 27.6228 5.85476 27.1036 6.43554",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281 0.817383)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMonitoring);
export default __webpack_public_path__ + "static/media/alert-monitoring.bbc76b19066563e7524829a89291b68e.svg";
export { ForwardRef as ReactComponent };